import { ArrowBack } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogSubmitPanel } from 'shared/components';

import { DeclineFeedbackFormData, DeclineReason } from '../../../types';
import AvailabilityInput from './AvailabilityInput';
import BaseInput, { ReasonInputBaseProps } from './BaseInput';
import LocationInput from './LocationInput';
import RoleInput from './RoleInput';
import ScheduleInput from './ScheduleInput';
import SkillsInput from './SkillsInput';

interface ReasonInputFormProps {
    onGoBack: () => void;
    onSubmit: () => void;
    isLoading: boolean;
    error?: string;
}

const reasonInputSections: Partial<Record<DeclineReason, (props: ReasonInputBaseProps) => React.ReactElement>> = {
    availability: AvailabilityInput,
    role: RoleInput,
    skills: SkillsInput,
    location: LocationInput,
    schedule: ScheduleInput
};

export default function ReasonInputForm({ onGoBack, onSubmit, isLoading, error }: ReasonInputFormProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails' });
    const { control, setValue } = useFormContext<DeclineFeedbackFormData>();
    const reason = useWatch({ control, name: 'primaryReason' });
    const ReasonInputSection = reasonInputSections[reason] || BaseInput;

    return (
        <div>
            <Button onClick={ onGoBack }
                startIcon={ <ArrowBack /> }
            >
                { t('actions.chooseDifferentReason') }
            </Button>

            <Stack pt={ 5 }
                spacing={ 3 }
            >
                <ReasonInputSection control={ control }
                    setValue={ setValue } />
            </Stack>

            <DialogSubmitPanel onSubmit={ onSubmit }
                isSubmitting={ isLoading }
                label={ t('actions.submit') }
                error={ error } />
        </div>
    );
}
